export var DEPLOY_DATE = new Date('2026-07-22T10:25:18+0000');
